import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as selectors from './selectors';
import * as utils from './utils';
import * as api from './api';
import reducer from './reducer';

export default {
    api,
    reducer,
    actionTypes,
    actions,
    selectors,
    utils,
};
